var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.508,
    height: 20.636,
    viewBox: "0 0 25.508 20.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "update",
    transform: "translate(-2 -3.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(2 3.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M26.273,14.64l-2.463-3.479a1.276,1.276,0,0,0-1.778-.3L18.552,13.32A1.275,1.275,0,1,0,20.027,15.4l1.165-.825A7.738,7.738,0,0,1,7.88,17.436a1.276,1.276,0,1,0-1.945,1.65A10.229,10.229,0,0,0,13.753,22.7a10.362,10.362,0,0,0,8.33-4.233,10.237,10.237,0,0,0,1.546-3.145l.562.793a1.276,1.276,0,0,0,2.082-1.474Z",
    transform: "translate(-1 -2.061)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M10.259,11.51a1.275,1.275,0,0,0-1.778-.3l-1.165.825A7.739,7.739,0,0,1,20.627,9.172a1.276,1.276,0,0,0,1.945-1.65A10.23,10.23,0,0,0,14.754,3.91a10.365,10.365,0,0,0-8.33,4.233,10.234,10.234,0,0,0-1.545,3.145l-.562-.794a1.275,1.275,0,1,0-2.082,1.473L4.7,15.446a1.276,1.276,0,0,0,1.778.3l3.479-2.463a1.276,1.276,0,0,0,.3-1.778Z",
    transform: "translate(-2 -3.91)",
    fill: "#67E1AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.bfa878c01ea85ac6e82fdfa865bda398.svg";
export { ForwardRef as ReactComponent };